/* everhound · PDP — primitivas de interface acessiveis.
   Tabs, accordions e modais aparecem em S1, S4, S8 e S12. Uma implementacao
   so: tres implementacoes divergentes de foco e a forma mais rapida de deixar
   a pagina intransitavel no teclado.

   Vanilla, sem dependencia. Nada aqui toca form ou carrinho. */
(function () {
  'use strict';

  /* Guarda de idempotencia. Varias sections incluem este asset para serem
     autossuficientes fora desta pagina; sem isto a IIFE roda uma vez por tag,
     duplicando listeners, observers e eventos (primitivas de interface). */
  if (window.__ehPdpUI) return;
  window.__ehPdpUI = true;

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  /* =============== TABS (role=tablist, navegacao por setas) =============== */
  document.querySelectorAll('[data-eh-tabs]').forEach(function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      emit('eh:tab', { tab: tab.dataset.ehTabId || tab.textContent.trim() });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var k = e.key, next = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft' || k === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') next = tabs[0];
        else if (k === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

  /* =============== ACCORDIONS (button aria-expanded) =============== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-eh-acc]');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = open;
    if (!open && btn.hasAttribute('data-eh-faq')) {
      emit('eh:faq-open', { question: btn.dataset.ehFaq || btn.textContent.trim().slice(0, 120) });
    }
  });

  /* =============== MODAIS (foco preso, Esc fecha, foco volta) =============== */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var openModal = null;
  var lastFocus = null;

  function show(modal) {
    /* Portal para o <body>.

       Por que: o tema usa view transitions e as sections carregam
       view-transition-name/transform. Qualquer um dos dois cria containing
       block, e um filho position:fixed passa a se posicionar e a empilhar
       DENTRO da section em vez de na viewport. Resultado: o header pintava
       por cima do modal e do overlay, e o que estivesse sobreposto roubava
       o clique. Movido para o body, o modal volta a ser global de verdade.
       Feito uma vez por modal, na primeira abertura. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
      /* Listener direto no X, alem da delegacao no document: se qualquer
         handler do tema chamar stopPropagation num clique dentro do modal,
         a delegacao nunca chega e o modal fica presa. O listener proprio
         dispara antes de qualquer bolha. */
      modal.querySelectorAll('[data-eh-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hide(); });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
    }

    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    openModal = modal;
    var first = modal.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function hide() {
    if (!openModal) return;
    openModal.hidden = true;
    document.body.style.overflow = '';
    openModal = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-eh-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-eh-modal-open'));
      if (m) { e.preventDefault(); show(m); }
      return;
    }
    if (e.target.closest('[data-eh-modal-close]')) { hide(); return; }
    /* Clique no backdrop fecha; clique no painel nao. */
    if (openModal && e.target === openModal) hide();
  });

  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
    if (e.key !== 'Tab') return;

    var items = Array.prototype.slice.call(openModal.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* =============== TOGGLE per-chew / daily (S4) =============== */
  document.querySelectorAll('[data-eh-dose-switch]').forEach(function (sw) {
    sw.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eh-dose-mode-btn]');
      if (!btn) return;
      var mode = btn.getAttribute('data-eh-dose-mode-btn');
      sw.querySelectorAll('[data-eh-dose-mode-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var target = document.getElementById(sw.getAttribute('data-eh-dose-switch'));
      if (target) {
        target.setAttribute('data-eh-dose-mode', mode);
        /* Reaplica o estado: quem multiplica os mg e o eh-pdp.js. */
        if (window.EH) window.EH.setTier(window.EH.state.tier, 'dose_toggle', true);
      }
      emit('eh:dose-toggle', { mode: mode });
    });
  });

  /* =============== FACADE DE VIDEO =============== */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-eh-video-play]');
    if (!play) return;
    e.preventDefault();
    var holder = play.closest('[data-eh-video]');
    if (!holder) return;
    var src = holder.getAttribute('data-eh-video-src');
    if (!src) return;

    var v = document.createElement('video');
    v.src = src;
    v.controls = true;
    v.playsInline = true;
    v.autoplay = true;
    v.preload = 'auto';
    v.className = 'eh-video__el';
    var poster = holder.getAttribute('data-eh-video-poster');
    if (poster) v.poster = poster;
    var track = holder.getAttribute('data-eh-video-captions');
    if (track) {
      var t = document.createElement('track');
      t.kind = 'captions'; t.src = track; t.default = true; t.srclang = 'en'; t.label = 'English';
      v.appendChild(t);
    }
    holder.innerHTML = '';
    holder.appendChild(v);
    emit('eh:video-play', {
      videoId: holder.getAttribute('data-eh-video') || 'unknown',
      sectionId: (holder.closest('[data-eh-section]') || {}).getAttribute
        ? holder.closest('[data-eh-section]').getAttribute('data-eh-section') : undefined
    });
  });
})();

/* A aba selecionada rola para dentro da tela quando a lista tem scroll. */
(function () {
  'use strict';
  if (window.__ehTabScroll) return;
  window.__ehTabScroll = true;
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    var lista = tab.parentElement;
    if (!lista || lista.scrollWidth <= lista.clientWidth) return;
    tab.scrollIntoView({ inline: 'nearest', block: 'nearest',
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

/* Bolinhas da galeria: rotulo com a linguagem do cliente ("image"), nao a do
   tema ("slide"). So troca o texto acessivel; o controle e o do tema. */
(function () {
  'use strict';
  if (window.__ehDots) return;
  window.__ehDots = true;
  function rotular() {
    var dots = document.querySelectorAll('.media-gallery__mobile-controls .slideshow-controls__dots button');
    if (!dots.length) return;
    dots.forEach(function (b, i) {
      b.setAttribute('aria-label', 'Go to image ' + (i + 1) + ' of ' + dots.length);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rotular);
  else rotular();
})();


/* M5 — contador de carrossel. So no mobile (o CSS esconde acima de 749px)
   e so em fila que realmente rola; fila que cabe na tela nao ganha
   contador, senao vira ruido. */
(function () {
  if (window.__ehRailCount) return;
  window.__ehRailCount = true;

  function montar() {
    document.querySelectorAll('.eh-rail--scroll').forEach(function (rail) {
      if (rail.dataset.ehCounted) return;
      var itens = rail.children.length;
      if (itens < 2) return;
      rail.dataset.ehCounted = '1';

      var p = document.createElement('p');
      p.className = 'eh-railcount';
      p.setAttribute('aria-live', 'polite');
      rail.insertAdjacentElement('afterend', p);

      function atualiza() {
        if (rail.scrollWidth <= rail.clientWidth + 1) { p.textContent = ''; return; }
        var passo = rail.scrollWidth / itens;
        var i = Math.min(itens, Math.round(rail.scrollLeft / passo) + 1);
        p.textContent = i + '/' + itens;
      }
      var pend = false;
      rail.addEventListener('scroll', function () {
        if (pend) return;
        pend = true;
        requestAnimationFrame(function () { pend = false; atualiza(); });
      }, { passive: true });
      window.addEventListener('resize', atualiza);
      atualiza();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montar);
  else montar();
})();

/* ===== T4 — vídeos de cliente sob a galeria, no desktop =====

   MOVE o bloco .eh-own__ugc que ja existe no S6, em vez de criar um
   segundo: duplicar markup carregaria os mesmos dois videos duas vezes na
   pagina. Uma ancora vazia fica no lugar original para a volta.

   A partir de 1024px o bloco vive sob as miniaturas da galeria e some do
   S6; abaixo disso volta para o S6. A troca acontece no resize, entao
   girar o aparelho nao deixa o bloco orfao. */
(function () {
  if (window.__ehUgcMove) return;
  window.__ehUgcMove = true;

  var MQ = window.matchMedia('(min-width: 1024px)');

  function aplicar() {
    var ugc = document.querySelector('.eh-own__ugc');
    if (!ugc) return;

    var ancora = document.querySelector('[data-eh-ugc-home]');
    if (!ancora) {
      ancora = document.createElement('div');
      ancora.setAttribute('data-eh-ugc-home', '');
      ugc.insertAdjacentElement('beforebegin', ancora);
    }

    var galeria = document.querySelector('.product-media-gallery__sticky-wrap')
               || document.querySelector('.product-information__media');

    if (MQ.matches && galeria) {
      if (!ugc.classList.contains('eh-own__ugc--gallery')) {
        ugc.classList.add('eh-own__ugc--gallery');
        galeria.appendChild(ugc);
      }
    } else if (ugc.classList.contains('eh-own__ugc--gallery')) {
      ugc.classList.remove('eh-own__ugc--gallery');
      ancora.insertAdjacentElement('afterend', ugc);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplicar);
  else aplicar();
  (MQ.addEventListener ? MQ.addEventListener.bind(MQ, 'change') : MQ.addListener.bind(MQ))(aplicar);
  window.addEventListener('resize', aplicar);
})();
